import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICommodity } from "../commodityModel";

export const getAllCommodity = createAsyncThunk(
  "Commodity/FindAllCommodity",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/FindAllCommodity`,
        {
          Commodity: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCommodity = createAsyncThunk(
  "Commodity/FindAllActiveCommodity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Commodity/FindAllActiveCommodity`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCommodity = createAsyncThunk(
  "Commodity/InsertCommodity",
  async (CommodityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/InsertCommodity`,
        CommodityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCommodity = createAsyncThunk(
  "Commodity/UpdateCommodity",
  async (CommodityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/UpdateCommodity`,
        CommodityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCommodityByID = createAsyncThunk(
  "Commodity/FindByIDCommodity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/FindByIDCommodity`,
        { commodity_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        commodity_guid: result.commodity_guid,
        name: result.name,
        description: result.description,
        isactive: result.isactive === true ? 1 : 2,
      } as ICommodity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const commodityActiveInactive = createAsyncThunk(
  "Commodity/ActiveInActiveCommodity",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/ActiveInActiveCommodity`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCommodity = createAsyncThunk(
  "Commodity/DeleteCommodity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Commodity/DeleteCommodity`,
        { commodity_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Commodity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
